import { render, staticRenderFns } from "./StampEdit.vue?vue&type=template&id=6241706a&scoped=true&"
import script from "./StampEdit.vue?vue&type=script&lang=ts&"
export * from "./StampEdit.vue?vue&type=script&lang=ts&"
import style0 from "./StampEdit.vue?vue&type=style&index=0&id=6241706a&scoped=true&lang=css&"
import style1 from "./StampEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241706a",
  null
  
)

export default component.exports